import { ApolloProvider } from "@apollo/client/react";

import client from "./apollo";

export default function TaxonomyApolloProvider(props) {
    return (
        <ApolloProvider client={ client }>
            { props.children }
        </ApolloProvider>
    );
}
